// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getinvoiceoption = createAsyncThunk('transistSliceData/getinvoiceoption', async () => {
    try {
        let response = await axios.get('/Invoice?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const gettransistinvoice = createAsyncThunk('transistSliceData/gettransistinvoice', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Report/transist-invoice?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const gettransistbankstatement = createAsyncThunk('transistSliceData/gettransistbankstatement', async () => {
    try {
        let response = await axios.get('/Report/transist-bankstatement', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteCurrency = createAsyncThunk('transistSliceData/deleteCurrency', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Currency/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency deleted successfully.');
        await dispatch(getStatement());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createStatement = createAsyncThunk('transistSliceData/createStatement', async (data, { dispatch }) => {
    console.log(data, 'datas');
    try {
        let response = await axios.post('/Report', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Currency added succesfully.');
        await dispatch(getStatement());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateCurrency = createAsyncThunk('transistSliceData/updateCurrency', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Currency/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Currency updated succesfully.');
        await dispatch(getStatement());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const TransistSlice = createSlice({
    name: 'transistSliceData',
    initialState: {
        transist: [],
        invoiceoption: [],
        transistinvoice: [],
        transistbankinvoice: []
    },
    reducers: {
        removeInvoiceoption: (state) => {
            state.invoiceoption = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getinvoiceoption.fulfilled, (state, action) => {
            state.invoiceoption = action?.payload;
            return;
        });
        builder.addCase(gettransistinvoice.fulfilled, (state, action) => {
            state.transistinvoice = action?.payload;
            return;
        });
        builder.addCase(gettransistbankstatement.fulfilled, (state, action) => {
            state.transistbankinvoice = action?.payload;
            return;
        });
    }
});
export const { removeInvoiceoption } = TransistSlice.actions;

export default TransistSlice.reducer;
